import { render, staticRenderFns } from "./orderhistorylisting.vue?vue&type=template&id=addeb81a&"
import script from "./orderhistorylisting.vue?vue&type=script&lang=js&"
export * from "./orderhistorylisting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports